import { InjectionToken } from '@angular/core';
import {
  GoogleLoginProvider,
  SocialAuthServiceConfig,
  SOCIAL_AUTH_CONFIG as SOCIAL_AUTH_SERVICE_CONFIG,
} from '@abacritt/angularx-social-login';
import { AUTH_CONTEXT_CONFIG, AuthContextConfig } from '@portal-front/portal-auth-shared-util-config';
import { DYNAMIC_LOCALE } from '@portal-front/util-locale';

// Token dla konfiguracji Social Auth (backward compatibility)
export const SOCIAL_AUTH_CONFIG = new InjectionToken<SocialAuthServiceConfig>('SOCIAL_AUTH_CONFIG');

const createSocialAuthConfig = (localeId: string, contextConfig: AuthContextConfig): SocialAuthServiceConfig => ({
  autoLogin: false,
  lang: localeId,
  providers: [
    {
      id: GoogleLoginProvider.PROVIDER_ID,
      // @TODO: Replace with client ID from environment variables (When EFN-3620 ready)
      provider: new GoogleLoginProvider(contextConfig.googleAuthClientId, {
        scopes: ['openid', 'profile', 'email'],
        oneTapEnabled: contextConfig.oneTapLoginEnabled !== false,
      }),
    },
  ],
});

export const socialAuthServiceConfig = [
  {
    provide: SOCIAL_AUTH_CONFIG,
    useFactory: createSocialAuthConfig,
    deps: [DYNAMIC_LOCALE, AUTH_CONTEXT_CONFIG],
  },
  {
    provide: 'SocialAuthServiceConfig',
    useFactory: createSocialAuthConfig,
    deps: [DYNAMIC_LOCALE, AUTH_CONTEXT_CONFIG],
  },
  {
    provide: SOCIAL_AUTH_SERVICE_CONFIG,
    useFactory: createSocialAuthConfig,
    deps: [DYNAMIC_LOCALE, AUTH_CONTEXT_CONFIG],
  },
];
